module.exports = __webpack_public_path__ + "static/things-hidden-since-the-foundation-of-the-world-7c583ed1550147384380338ab9593d6e.jpg";